import type { PropertyAlertRequestBody } from "./propertyAlertPayload";

const STORAGE_KEY = "@7Cantos:pendingPropertyAlert";

function isRecord(v: unknown): v is Record<string, unknown> {
  return typeof v === "object" && v !== null && !Array.isArray(v);
}

export function savePendingPropertyAlert(payload: PropertyAlertRequestBody): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {
    /* ignore quota / private mode */
  }
}

/** Lê e remove do storage (evita double-submit em re-renders). */
export function takePendingPropertyAlert(): PropertyAlertRequestBody | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    sessionStorage.removeItem(STORAGE_KEY);
    const parsed: unknown = JSON.parse(raw);
    if (!isRecord(parsed)) return null;
    if (typeof parsed.max_rent !== "number" || typeof parsed.min_rooms !== "number") {
      return null;
    }
    if (parsed.segment !== "residential" && parsed.segment !== "commercial") {
      return null;
    }
    return parsed as PropertyAlertRequestBody;
  } catch {
    return null;
  }
}
